var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottleCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.bottlecap-st0{fill:#FFFFFF;stroke:currentColor;stroke-miterlimit:15.1181;}\r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bottlecap-st0",
    d: "M59.3,38.4C59.3,38.4,59.3,38.4,59.3,38.4l0-0.3v0.1c0-1.5-1.2-2.7-2.7-2.7H22.1c-1.4,0-2.6,1.1-2.7,2.6l0,0.3c0,0,0,0,0,0 c-0.2,0-0.4,0.2-0.4,0.4v4.7c0,0.2,0.2,0.4,0.4,0.4c0,0,0,0,0,0l0,0.7h39.8l0-0.7c0,0,0,0,0,0c0.2,0,0.4-0.2,0.4-0.4v-4.7 C59.7,38.6,59.5,38.4,59.3,38.4z M22.8,43.4c0,0.2-0.2,0.4-0.4,0.4S22,43.7,22,43.4v-4.7c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4 V43.4z M28.4,43.4c0,0.2-0.2,0.4-0.4,0.4s-0.4-0.2-0.4-0.4v-4.7c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4V43.4z M34.1,43.4 c0,0.2-0.2,0.4-0.4,0.4s-0.4-0.2-0.4-0.4v-4.7c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4V43.4z M39.7,43.4c0,0.2-0.2,0.4-0.4,0.4 S39,43.7,39,43.4v-4.7c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4V43.4z M45.4,43.4c0,0.2-0.2,0.4-0.4,0.4s-0.4-0.2-0.4-0.4v-4.7 c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4V43.4z M51,43.4c0,0.2-0.2,0.4-0.4,0.4s-0.4-0.2-0.4-0.4v-4.7c0-0.2,0.2-0.4,0.4-0.4 s0.4,0.2,0.4,0.4V43.4z M56.7,43.4c0,0.2-0.2,0.4-0.4,0.4s-0.4-0.2-0.4-0.4v-4.7c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4V43.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottleCap);
export default __webpack_public_path__ + "static/media/bottleCap.52673e67538f382e9f69713fa7addcd7.svg";
export { ForwardRef as ReactComponent };